import { useState } from "react";

import GroupMemberWorkflowData from "./GroupMemberWorkflowData";

const useGroupMemberWorkflowData = () => {
  const [groupMemberWorkflowState, setGroupMemberWorkflowState] = useState(GroupMemberWorkflowData.INITIAL_GROUP_MEMBER_WORKFLOW_STATE);

  const putGroupMemberStepStatus = (workflowId, groupMemberStatusObj) => {
    return GroupMemberWorkflowData.putGroupMemberStepStatusData(workflowId, groupMemberStatusObj, groupMemberWorkflowState, setGroupMemberWorkflowState);
  };

  return {
    groupMemberWorkflowState,
    putGroupMemberStepStatus
  };
};

export default useGroupMemberWorkflowData;